import { render, staticRenderFns } from "./CommentInputSection.vue?vue&type=template&id=77878305&scoped=true"
import script from "./CommentInputSection.vue?vue&type=script&lang=ts"
export * from "./CommentInputSection.vue?vue&type=script&lang=ts"
import style0 from "./CommentInputSection.vue?vue&type=style&index=0&id=77878305&prod&lang=scss&scoped=true"
import style1 from "./CommentInputSection.vue?vue&type=style&index=1&id=77878305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77878305",
  null
  
)

export default component.exports